var _defs, _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 150 34.63",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".d{fill:#00347e;}.e{fill:#979797;}.f{fill:#d90011;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "a"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "b"
  }, /*#__PURE__*/React.createElement("g", {
    id: "c"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "e",
    points: "71.87 1.79 77.11 1.79 77.11 19.26 85.83 19.26 85.83 23.69 71.87 23.69 71.87 1.79"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M86.68,18.58c0-4.73,2.74-5.78,9.06-5.78h.63c-.09-1.4-.59-2.55-2.34-2.55-1.99,0-3.46,.42-4.48,.89l-1.89-3.63c1.56-.78,3.74-1.34,6.91-1.34,4.86,0,6.35,2.12,6.35,6.3v6c0,1.05,.44,1.31,1.57,1.31v3.9c-.5,.06-1.31,.06-1.76,.06-2.24,0-3.07-.21-3.61-1.39-.94,1.06-2.33,1.54-4.86,1.54-4.61,0-5.58-2.26-5.58-5.29m9.68-1.34v-1.54h-.59c-3.49,0-4.61,.45-4.61,2.38,0,1.48,.55,2.11,2.19,2.11,1.83,0,3.01-.63,3.01-2.94"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M120.25,15.2c0-5.27,1.52-8.69,7.79-8.69s7.75,3.48,7.75,8.69-1.46,8.74-7.75,8.74-7.79-3.41-7.79-8.74m10.8,.15c0-2.94-.3-4.64-3.02-4.64s-3.02,1.7-3.02,4.64,.31,4.67,3.02,4.67,3.02-1.76,3.02-4.67"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "e",
    points: "136.76 20.7 143.8 10.73 137.19 10.73 137.19 6.81 149.72 6.81 149.72 9.84 142.61 20.02 150 20.02 150 23.67 136.76 23.67 136.76 20.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M114.42,17.5s.02,.03,.02,.05c0,.06-.05,.11-.1,.11h-.19c-.91,0-1.71-.51-2.13-1.26l-.02-.03c-.65-.98-4.38-14.58-4.38-14.58h-5.2l6.86,22.03h5.82L121.98,1.8h-5.19l-3.17,10.87-.08,.27c-.52,1.73-.22,3.45,.88,4.57"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M23.38,15.44c-.4,2.58-2.06,8.81-11.61,8.81C5.18,24.25,0,20.19,0,11.76,0,5.03,3.82,0,12.08,0c9.29,0,10.66,6.71,10.99,7.94h-4.06c-.23-.79-1.83-4.06-6.7-4.06-5.75,0-8.15,3.59-8.15,8.38,0,5.31,3.46,8.11,7.92,8.11,4.74,0,6.83-3.14,7.23-4.94h4.06Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "d",
    x: 25.56,
    y: 0.58,
    width: 3.54,
    height: 23.11
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M47.32,23.69h-3.5v-2.13c-1.06,1.21-2.63,2.7-5.75,2.7s-6-1.49-6-6.71V6.61h3.54v9.47c0,3.37,.92,4.8,3.29,4.8,2.82,0,3.97-1.3,4.86-2.51V6.61h3.55V23.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M50.15,.58h3.55v7.82c1.52-1.2,2.95-2.35,5.9-2.35,5.07,0,8.24,3.83,8.24,9,0,5.78-3.75,9.21-8.09,9.21-3.52,0-5.36-1.9-6.08-2.76v2.19h-3.5V.58Zm3.55,17.83c1.37,1.18,2.81,2.48,5.24,2.48,2.75,0,5.29-1.97,5.29-5.72s-2.69-5.76-5.41-5.76c-2.57,0-4.03,1.37-5.12,2.35v6.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M67.91,34.63v-.12c.03-1.2-.25-2.28-1.36-3.23-1.12-.95-2.39-1.47-3.86-1.54-5.38-.26-8.76,.86-14.99,4.89h20.21Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.06b3c8703279453d49ec1eb295fe9b4c.svg";
export { ForwardRef as ReactComponent };